import React from 'react';
import ProductSpecificQuestionsList from "../../../components/Admin/Product/ProductSpecificQuestionsList";

const AdminProductSpecificQuestions = () => {

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className={"sl-container sl-m-auto sl-my-8"}>

                    <h1 className={`sl-font sl-mb-10 sl-text-xl sl-text-gray-900`}>Product Specific Questions</h1>
                    <ProductSpecificQuestionsList></ProductSpecificQuestionsList>

                </div>
            </main>
        </div>
    );
};

export default AdminProductSpecificQuestions;
